import React from "react";

import { toast } from "react-toastify";
import classes from "./masterSparesVariantDetailPage.module.css";

import {
  useGetMasterSparesVariantByIdQuery,
  useAddMasterSparesVariantMutation,
  useUpdateMasterSparesVariantMutation,
  useDeleteMasterSparesVariantMutation,
} from "../../../../../services/master/masterSparesVariantApiSlice";

import { SparesVariantForm } from "../../../../../component/masters/spares/sparesVariant/sparesVariantForm/SparesVariantForm";
import { useNavigate, useParams } from "react-router-dom";

export const MasterSparesVariantDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
 

  const isEditMode = Boolean(id);

  const { data, isLoading } = useGetMasterSparesVariantByIdQuery(id, {
    skip: !isEditMode,
  });

  const [addVariant, addState] = useAddMasterSparesVariantMutation();
  const [updateVariant, updateState] = useUpdateMasterSparesVariantMutation();
  const [deleteVariant, deleteState] = useDeleteMasterSparesVariantMutation();

  const initialValues =
    data || {
      brand: "",
      model: "",
      color: "",
      part_name: "",
      price: "",
      original_price: "",
      spare_image: "",
      about_this_item: [],
      product_details: [],
      specifications: [{ name: "", value: "" }],
      FAQs: [{ name: "", value: "" }],
    };

  const handleSubmit = async (formData) => {
    try {
      if (isEditMode) {
        await updateVariant({ id, ...formData }).unwrap();
        toast.success("Updated successfully!");
      } else {
        await addVariant(formData).unwrap();
        toast.success("Added successfully!");
      }
      navigate(-1);
    } catch (err) {
      toast.error("Failed.");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this variant?")) return;
    try {
      await deleteVariant(id).unwrap();
      toast.success("Deleted!");
      navigate(-1);
    } catch (err) {
      toast.error("Failed.");
    }
  };

  if (isEditMode && isLoading) {
    return <div>Loading…</div>;
  }

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>
        {isEditMode ? "Edit Variant" : "Add Variant"}
      </h2>

      <SparesVariantForm
        initialValues={initialValues}
        isEditMode={isEditMode}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        isSubmitting={addState.isLoading || updateState.isLoading}
        isDeleting={deleteState.isLoading}
      />
    </div>
  );
};
